import { MedrecordMoment } from '@medrecord/services-datetime';
import { ResourceType } from '../enums/resource-type.enum';
import { ResourceBlockFunction } from '../interfaces/resource-block-function.interface';

export const drugUseBlock: ResourceBlockFunction = () => ({
  resourceType: ResourceType.observation,
  fieldGroups: [
    {
      name: ({ resource }) => resource?.content?.drugType?.coding?.[0]?.display || 'my_doctor_drug',
      fields: [
        {
          label: 'my_doctor_start_date',
          fieldName: 'period',
          prepareData: (data) => (data?.start ? MedrecordMoment(data?.start).format('LLL') : ''),
        },
        {
          label: 'my_doctor_end_date',
          fieldName: 'period',
          prepareData: (data) => (data?.end ? MedrecordMoment(data?.end).format('LLL') : ''),
        },
        {
          label: 'my_doctor_amount',
          fieldName: 'amount',
          prepareData: (data) => data,
        },
        {
          label: 'my_doctor_comment',
          fieldName: 'comment',
          prepareData: (data) => data,
        },
        {
          label: 'my_doctor_status',
          fieldName: 'status',
          prepareData: (data) => data?.coding?.[0]?.display,
        },
        {
          label: 'my_doctor_administration_route',
          fieldName: 'administrationRoute',
          prepareData: (data) => data?.coding?.[0]?.display,
        },
      ],
    },
  ],
});
